export default "__VITE_ASSET__BEHepyNA__"